/**
 * KV Message types
 * @alpha
 */
export var KVMessageType;
(function (KVMessageType) {
    KVMessageType["REQ_KEY_VALUE_LIST"] = "REQ_KEY_VALUE_LIST";
    KVMessageType["REQ_KEY_VALUE_READ"] = "REQ_KEY_VALUE_READ";
})(KVMessageType || (KVMessageType = {}));
/**
 * KV Event Message types
 * @alpha
 */
export var KVEventMessageType;
(function (KVEventMessageType) {
    KVEventMessageType["EVENT_KEY_VALUE_PUT"] = "EVENT_KEY_VALUE_PUT";
    KVEventMessageType["EVENT_KEY_VALUE_DELETE"] = "EVENT_KEY_VALUE_DELETE";
})(KVEventMessageType || (KVEventMessageType = {}));
